export default __webpack_public_path__ + "static/media/b_creativity_small.466fc6e2.png";